import {invalidateQueries, q} from "../../state";
import {
  CreateOperationalContext,
  OperationalContextId,
  ThirdPartyId,
  TprmAssetId,
  UpdateOperationalContext,
} from "platformed-client/types";
import {platformedClient} from "..";

export async function create(operationalContext: CreateOperationalContext) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/operational_contexts", {
    body: operationalContext,
  });
  await invalidateQueries([q.tprm.thirdPartyOperationalContexts.filter(operationalContext.third_party_id)]);
  return res;
}

export async function get(operationalContextId: OperationalContextId) {
  return await platformedClient.internalRequest(
    "get",
    "/region/{region}/api/tprm/operational_contexts/{operational_context_id}",
    {path: {operational_context_id: operationalContextId}},
  );
}

export async function update(
  thirdPartyId: ThirdPartyId,
  operationalContextId: OperationalContextId,
  update: UpdateOperationalContext,
) {
  const res = await platformedClient.internalRequest(
    "patch",
    "/region/{region}/api/tprm/operational_contexts/{operational_context_id}",
    {path: {operational_context_id: operationalContextId}, body: update},
  );
  await invalidateQueries([
    q.tprm.thirdPartyOperationalContexts.filter(thirdPartyId),
    q.tprm.operationalContext.filter(operationalContextId),
  ]);
  return res;
}

export async function delete_(thirdPartyId: ThirdPartyId, operationalContextId: OperationalContextId) {
  const res = await platformedClient.internalRequest(
    "delete",
    "/region/{region}/api/tprm/operational_contexts/{operational_context_id}",
    {path: {operational_context_id: operationalContextId}},
  );
  await invalidateQueries([
    q.tprm.thirdPartyOperationalContexts.filter(thirdPartyId),
    q.tprm.operationalContext.filter(operationalContextId),
  ]);
  return res;
}

export async function linkAsset(
  thirdPartyId: ThirdPartyId,
  operationalContextId: OperationalContextId,
  assetId: TprmAssetId,
) {
  const res = await platformedClient.internalRequest(
    "put",
    "/region/{region}/api/tprm/operational_contexts/{operational_context_id}/assets/{asset_id}",
    {path: {operational_context_id: operationalContextId, asset_id: assetId}},
  );
  await invalidateQueries([
    q.tprm.thirdPartyOperationalContexts.filter(thirdPartyId),
    q.tprm.operationalContext.filter(operationalContextId),
  ]);
  return res;
}

export async function unlinkAsset(
  thirdPartyId: ThirdPartyId,
  operationalContextId: OperationalContextId,
  assetId: TprmAssetId,
) {
  const res = await platformedClient.internalRequest(
    "delete",
    "/region/{region}/api/tprm/operational_contexts/{operational_context_id}/assets/{asset_id}",
    {path: {operational_context_id: operationalContextId, asset_id: assetId}},
  );
  await invalidateQueries([
    q.tprm.thirdPartyOperationalContexts.filter(thirdPartyId),
    q.tprm.operationalContext.filter(operationalContextId),
  ]);
  return res;
}
